const docTypes = {
    "DOCKER": "DOCKER",
    "LAMBDA": "LAMBDA",
    "PROGRAMMING": "PROGRAMMING",
    "LOGS": "LOGS"
}

export default docTypes;